/* eslint-disable vars-on-top */
/* eslint-disable prettier/prettier */
// =require components/sliders.js
// =require components/accordion.js
// =require components/filter.js
// =require components/incrementals.js
// =require components/search.js
// =require components/collection-filter.js



// Instead, use the global jQuery that's loaded from CDN
import $ from 'jquery'
const jQuery = window.jQuery;

function matchCircleHeight($el) {
  var height = Math.ceil($el.innerHeight());
  $el.css('width', height);
  $el.css('margin-left', -height / 2);
}


// Wait for DOM and ensure jQuery is available
document.addEventListener('DOMContentLoaded', function() {
  // Check if jQuery is loaded
  if (typeof window.jQuery === 'undefined') {
    console.error('jQuery is not loaded!');
    return;
  }

  // Import slick after jQuery is available
  import('slick-carousel')
    .then(() => {
      // Initialize components that depend on jQuery and slick
      initializeComponents();
    })
    .catch(err => console.error('Error loading slick:', err));

});

// Then your other imports
import './scripts/components/sliders.js';
import './scripts/components/accordion.js';
import './scripts/components/filter.js';
import './scripts/components/incrementals.js';
import './scripts/components/search.js';
import './scripts/components/collection-filter.js';
import './scripts/vendor.mjs';
import './scripts/account.js';
import './scripts/yotpo-reviews-lazyload.js';
import './core.scss'


// Create a function to initialize all jQuery-dependent components
function initializeComponents() {
  // Set Animation Speed
  var animSpeed = 200;

  // Initialize main menu hider
  MainMenuHider();

  // Initialize all jQuery components
  $(document).ready(function() {
    // Menu Hider
    MainMenuHider();


    $(document).ready(function() {
      // Animated circle sizing on homepage. Width needs to match the height.
      var $circle = $('[data-homepage-circle]');
      if ($circle.length) {
        matchCircleHeight($circle);
        $(window).on('resize', function() {
          matchCircleHeight($circle);
        });
      }
    });

    $('[data-toggle-search]').on('click', function () {
      $('[data-search]').slideToggle();
    });


    // Blog filter toggle for small devices.
    $('[data-tags-toggle]').on('click', function(e){
      e.preventDefault();
      var $toggle = $(this);
      var $parent = $toggle.parent().parent('.tags');
      $parent.toggleClass('is-toggled');
    });

    // Store the actual handler function
    const desktopNavClickHandler = function(e) {
      var $this = $(this);
      var html = document.querySelector('html');
      var subId;

      e.preventDefault();

      if ($this.hasClass('active')) {
        subId = $this.data('submenu-id');
        $('#' + subId).removeClass('active');
        $this.removeClass('active');
        html.setAttribute('data-nav-open', 'false');
        anime({
          targets: '[data-nav-bg]',
          opacity: 0,
          duration: animSpeed,
          easing: 'easeInOutQuad',
          begin: function() {
            document.querySelector('[data-nav-bg]').style.display = 'block';
          },
          complete: function() {
            document.querySelector('[data-nav-bg]').style.display = 'none';
          }
        });
      } else {
        $('[data-main-nav] a.top-level, [data-main-nav] button.top-level').each(function() {
          $(this).removeClass('active');
        });
        $('[data-submenu-desktop]').each(function() {
          $(this).removeClass('active');
        });
        subId = $this.data('submenu-id');
        $('#' + subId).addClass('active');
        $this.addClass('active');
        html.setAttribute('data-nav-open', 'true');
        anime({
          targets: '[data-nav-bg]',
          opacity: 0.3,
          duration: animSpeed,
          easing: 'easeInOutQuad',
          begin: function() {
            document.querySelector('[data-nav-bg]').style.display = 'block';
          }
        });
      }
    };

    // Desktop Dropdown Clicks - Attach the stored handler
    $(document).on('click', '[data-main-nav] a.top-level, [data-main-nav] button.top-level', desktopNavClickHandler);

    // Desktop Menu Closer
    $('[data-nav-bg]').on('click', function(e) {
      var html = document.querySelector('html');
      e.preventDefault();
      $('[data-main-nav] a.top-level, [data-main-nav] button.top-level').each(function() {
        $(this).removeClass('active');
      });
      $('[data-submenu-desktop]').each(function() {
        $(this).removeClass('active');
      });
      html.setAttribute('data-nav-open', 'false');
      anime({
        targets: '[data-nav-bg]',
        opacity: 0,
        duration: animSpeed,
        easing: 'easeInOutQuad',
        begin: function() {
          document.querySelector('[data-nav-bg]').style.display = 'block';
        },
        complete: function() {
          document.querySelector('[data-nav-bg]').style.display = 'none';
        }
      });
    });

    // Mobile Menu Click
    $('.hamburger').on('click', function(e) {
      var $this = $(this);
      var html = document.querySelector('html');
      e.preventDefault();
      if ($this.hasClass('is-active')) {
        $('[data-mobile-dropdown]').removeClass('active');
        html.setAttribute('data-mobile-nav-open', 'false');
        anime({
          targets: '[data-mobile-bg]',
          opacity: 0,
          duration: animSpeed,
          easing: 'easeInOutQuad',
          begin: function() {
            document.querySelector('[data-nav-bg]').style.display = 'block';
          },
          complete: function() {
            document.querySelector('[data-nav-bg]').style.display = 'none';
          }
        });
      } else {
        $('[data-mobile-dropdown]').addClass('active');
        html.setAttribute('data-mobile-nav-open', 'true');
        anime({
          targets: '[data-mobile-bg]',
          opacity: 0.3,
          duration: animSpeed,
          easing: 'easeInOutQuad',
          begin: function() {
            document.querySelector('[data-nav-bg]').style.display = 'block';
          }
        });
      }
      $this.toggleClass('is-active');
    });

    // Mobile Dropdown Clicks
    $('[data-mobile-dropdown] a.top-level').on('click', function(e) {
      var $this = $(this);
      var submenu = '#' + $this.data('mobile-submenu-id');
      var translateYAmount;
      e.preventDefault();
      if ($this.hasClass('active')) {
        if ($this.next('ul').hasClass('image-menu')) {
          translateYAmount = '-50%';
        } else {
          translateYAmount = '0px';
        }
        anime({
          targets: submenu,
          opacity: 0,
          translateY: ['0px', translateYAmount],
          duration: 200,
          easing: 'easeInOutQuad',
          begin: function() {
            if ($this.next('ul').hasClass('image-menu')) {
              $this.next('ul').css('display', 'flex');
            } else {
              $this.next('ul').css('display', 'block');
            }
          },
          complete: function() {
            $this.next('ul').css('display', 'none');
          }
        });
        $this.next('ul').removeClass('active');
        $this.removeClass('active');
      } else {
        anime({
          targets: submenu,
          opacity: 1,
          translateY: ['-30%', '0px'],
          duration: 200,
          easing: 'easeInOutQuad',
          begin: function() {
            if ($this.next('ul').hasClass('image-menu')) {
              $this.next('ul').css('display', 'flex');
            } else {
              $this.next('ul').css('display', 'block');
            }
          }
        });
        $this.next('ul').addClass('active');
        $this.addClass('active');
      }

    });

    // read more
    $('.readmore').click(function(e) {
      e.preventDefault();
      var that = this;
      $(this)
        .text(function(i, t) {
          return t == $(that).data('read-less') ? $(that).data('read-more') : $(that).data('read-less');
        })
        .prev('.readmore-content')
        .slideToggle();
    });

    // show more
    $('.show-more').click(function(e) {
      e.preventDefault();
      const lessText = $(this).data('less-text') || 'Show Less';
      const moreText = $(this).data('more-text') || 'Show More';
      $(this)
        .text(function(i, t) {
          return t === lessText ? moreText : lessText;
        })
        .prev('.show-more-content')
        .slideToggle();
    });

    // Featured Products section
    $('.featured-prod-container').click( function() {
      $(this).find('.product-card').slideToggle() // show the product card on hover
    })

    // Slide featured product card info in/out on hover
    $('.featured-prod-container').hover(function() {
      $(this).find('.product-card').slideDown();
    }, function() {
      $(this).find('.product-card').slideUp();
    });

    // Content Fade In Observer
    (function ContentFadeIn() {
      var options = {
        rootMargin: '100px',
        threshold: [0, 0.25, 0.5, 0.75, 1.0]
      };
      var observer = new IntersectionObserver(contentInView, options);
      var $images = $('.content-fade-in');
      var i = 0;
      var il = $images.length;
      for (; i < il; i += 1) {
        observer.observe($images[i]);
      }
      function contentInView(evt) {
        var target;
        var intersectionRatio;
        i = 0;
        il = evt.length;
        for (; i < il; i += 1) {
          target = evt[i].target;
          intersectionRatio = evt[i].intersectionRatio;
          if (intersectionRatio === 0) {
            // $(target).removeClass('content-in-view');
          } else if (intersectionRatio > 0.5) {
            // eslint-disable-next-line
            $(target).addClass('content-in-view');
          }
          if (evt[i].boundingClientRect.top < 0) {
            target.setAttribute('data-seen', true);
          } else {
            target.removeAttribute('data-seen');
          }
        }
      }
    })();


    document.addEventListener('DOMContentLoaded', function () {
      const elements = document.querySelectorAll('.content-fade-in');
      if (!elements.length) return;

      if (!('IntersectionObserver' in window)) {
        elements.forEach(function (el) {
          el.classList.add('is-visible');
        });
        return;
      }

      const observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -120px 0px',
        threshold: 0
      });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    });


    // Accordion
    $('.js-accordion').each(function() {
      window.Facedr.Accordion(this);
    });

    // Image toggler a-b-images
    $('[data-image-toggler]').each(function(){
      var $el = $(this);
      var $toggleBtn = $el.find('[data-image-toggler-target]');

      $toggleBtn.on('click', function() {
        var $btn = $(this);
        var imageTarget = $btn.data('image-toggler-target');
        var $images = $el.find('[data-toggle-image]');

        $toggleBtn.removeClass('is-active');
        $btn.addClass('is-active');

        $images.removeClass('z-10').addClass('z-0');
        $el.find('[data-toggle-image=' + imageTarget + ']').addClass('z-10');

      });
    });

    $('[data-collection-filter]').each(function() {
      // eslint-disable-next-line no-new,no-undef
      new CollectionFilter(this);
    });

    function toggleItems() {
      var $filters = $('[data-filter]:checked');
      var handles = '';
      var $allItems = $('[data-shop-item]');
      var $noItems = $('[data-no-items]');
      var $productCountSpan = $('[data-product-count]');
      var $dynamicTitle = $('[data-dynamic-title="true"]');

      $filters.each(function() {
        handles += '[data-filter-' + $(this).data('filter') + ']';
      });

      $noItems.addClass('hidden');
      $allItems.removeClass('flex');
      $allItems.addClass('hidden');

      var $filteredItems = $('[data-shop-item]' + handles);
      $filteredItems.removeClass('hidden');
      $filteredItems.addClass('flex');

      var currentProductCount = $filteredItems.length;

      if ($productCountSpan.length > 0) {
        $productCountSpan.text(currentProductCount);
      }

      if ($dynamicTitle.length > 0) {
        var template = $dynamicTitle.data('title-template');
        if (template) {
          var newText = String(template).replace('%%COUNT%%', currentProductCount);
          $dynamicTitle.text(newText);
        }
      }

      if($filteredItems.length === 0) {
        $noItems.removeClass('hidden');
      }
    }

    if($('.shop-filters').length > 0) {
      $('[data-toggle]').on('click', function() {
        var $this = $(this);
        var type = $this.data('toggle');
        $('[data-arrow="' + type + '"]').toggleClass('rotate-180');
        $('[data-filters="' + type + '"]').toggleClass('hidden');
      });

      $('[data-filter]').on('click', function() {
        var $this = $(this);
        var status = $this.prop('checked');
        var unique = $this.data('unique');
        if(unique) {
          $('[data-unique="' + unique + '"]').prop('checked', false);
          $this.prop('checked', status);
        }
        toggleItems();
      });

      $('[data-filter-drawer-toggle]').on('click', function() {
        $('.shop-filter-drawer').toggleClass('active');
      });

      $('[data-reset-filters]').on('click', function() {
        $('[data-filter]').prop('checked', false);
        toggleItems();
      });
    }

    // Tabs
    // Show the first tab and hide the rest
    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').css('display', 'none');
    $('.tab-content:first').css('display', 'block');;

    // Click function
    $('#tabs-nav li').click(function(){
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').css('display', 'none');
      var activeTab = $(this).find('a').attr('href');

      $(activeTab).css('display', 'block');
      setTimeout(function() {
        window.dispatchEvent(new Event('resize'));
        $('.regime-slider.am').slick('refresh');
        $('.regime-slider.pm').slick('refresh');
      }, 50);

      return false;
    });

    // IMPORTANT: Set the core navigation handler for the queue
    if (typeof window.setCoreNavHandler === 'function') {
      window.setCoreNavHandler(desktopNavClickHandler);
    }
  });
}

// Nav Hider (Uses Scrolldir)
function MainMenuHider() {
  var html = document.querySelector('html');
  window.addEventListener(
    'scroll',
    function() {
      var currentScroll = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
      if (currentScroll > 200) {
        if (html.getAttribute('data-disable-nav-hide') !== 'true') {
          html.setAttribute('data-allow-nav-hide', 'true');
        } else {
          html.setAttribute('data-allow-nav-hide', 'false');
        }
      } else {
        html.setAttribute('data-allow-nav-hide', 'false');
      }
    },
    { passive: true }
  );
}


document.addEventListener('DOMContentLoaded', function() {
  const updateButton = document.getElementById('cart-update-button');
  const quantityInputs = document.querySelectorAll('input[name="updates[]"]');

  if (!updateButton || quantityInputs.length === 0) {
    if (updateButton) updateButton.classList.add('btn-disabled');
    return;
  }

  const initialQuantities = new Map();
  quantityInputs.forEach(input => {
    initialQuantities.set(input.id, input.value);
  });

  function checkAndUpdateButtonVisibility() {
    let hasChanged = false;
    quantityInputs.forEach(input => {
      if (input.value !== initialQuantities.get(input.id)) {
        hasChanged = true;
      }
    });

    if (hasChanged) {
      updateButton.classList.remove('btn-disabled');
      updateButton.removeAttribute('disabled');
    } else {
      updateButton.classList.add('btn-disabled');
      updateButton.setAttribute('disabled', 'disabled');
    }
  }

  quantityInputs.forEach(input => {
    input.addEventListener('input', checkAndUpdateButtonVisibility);

    const parentContainer = input.closest('.quantity-input');
    if (parentContainer) {
        const buttons = parentContainer.querySelectorAll('button[data-action]');
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                // Value might update after a slight delay, use setTimeout to ensure check happens after update
                setTimeout(checkAndUpdateButtonVisibility, 0);
            });
        });
    }
  });
});
